export const icon_opacity_enabled = "0.82";
export const icon_opacity_disabled = "0.54";

export const backgroud_success = "#E6F5EE";
